export default "__VITE_ASSET__c5RbdqVm__"